const WORDS = ["JIU-JITSU", "FOCO", "DISCIPLINA", "CORPO", "MENTE", "ESPÍRITO", "AMOR", "AMPARO", "ESPORTE", "EDUCAÇÃO", "RESPEITO"];

export default function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <div className="relative border-y border-white/10 py-6 overflow-hidden bg-surface/40" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee gap-0">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((w, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className={`font-display text-3xl sm:text-5xl font-extrabold tracking-tight px-6 ${i % 2 === 0 ? "text-outline-gold" : "text-zinc-700"}`}>
                  {w}
                </span>
                <span className="text-crimson text-2xl">✕</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
